import { useTranslations } from "next-intl";
import Offcanvas from "../Offcanvas";
import QuickAddToClosetOffCanvasVariants from "./QuickAddToClosetOffCanvasVariants";

function QuickAddToClosetOffCanvas({ show, onHide, productWithVariants, dataFromAlgolia }) {
  const t = useTranslations("common");

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="bottom"
      title={t("quick_add_to_closet.offcanvas.title")}
    >
      <QuickAddToClosetOffCanvasVariants
        productWithVariants={productWithVariants}
        onHide={onHide}
        dataFromAlgolia={dataFromAlgolia}
      />
    </Offcanvas>
  );
}

export default QuickAddToClosetOffCanvas;
